module.exports = __webpack_public_path__ + "img/CYM.9921d51c.svg";